module.exports = __webpack_public_path__ + "e1ead6d4a9f6304e75f9679b1408411d.pdf";